// src/components/ProtectedRoute.js
import React from "react";
import { useAuth } from "./AuthContextProvider";
import { Navigate } from "react-router-dom";
export type ProtectedRouteProps = {
  children: JSX.Element;
};
export const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const { user } = useAuth();

  if (user?.firstLogin) {
    return <Navigate to="/set-password" />;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return children;
};
